module.exports = __webpack_public_path__ + "1792395595471/images/paypal.744232e.png";